import type { FC } from 'react'

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { match } from 'ts-pattern'

import { DialogButton } from '~/core/components/dialog-button'
import { UserApi } from '~/services/fm/user'
import CenterCircularProgress from '~/shared/components/center-circular-progress'
import useAppNavigate from '~/shared/navigation/use-app-navigate'
import { EGuildRole } from '~/shared/types/services/user'

export const GuildGuardWithRole: FC<{ requireOneOfRole: EGuildRole[] }> = (props) => {
  const { data: userGuildRole } = UserApi.getUserGuildRole.useQuery()

  const granted = props.requireOneOfRole.some(
    (role) =>
      // eslint-disable-next-line no-bitwise
      !!((userGuildRole?.role || 0) & role)
  )

  const navigate = useAppNavigate()
  return match(userGuildRole)
    .with(undefined, () => <CenterCircularProgress />)
    .otherwise(() =>
      match(granted)
        .with(true, () => <>{props.children}</>)
        .otherwise(() => (
          <>
            <Dialog open>
              <DialogTitle>错误</DialogTitle>
              <DialogContent>
                <DialogContentText>您没有权限访问该页面，请联系公会会长或管理员</DialogContentText>
              </DialogContent>
              <DialogActions>
                <DialogButton variant="primary" onClick={() => navigate('/')}>
                  确认
                </DialogButton>
              </DialogActions>
            </Dialog>
          </>
        ))
    )
}
